<section class="section section--credit-summary" *ngIf="isRequestApproved">
  <div class="container">
    <div class="wrapper">
      <div class="content fadeinright animation-duration-300">
        <form class="form full__height">
          <div class="content__main">
            <article class="mainInfo pb-30">
              <i class="icon icon-success mb-10">
                <app-success-icon color="color"></app-success-icon>
              </i>
              <h1 class="pb-10">¡Felicitaciones!</h1>
              <p>Tu Kredicash ha sido aprobado.</p>
            </article>

            <article class="simulator__result mb-30" *ngIf="isApprovedEqual() || isApprovedLess() || isBetterProduct()">
              <div class="result__block">
                <div class="result__title">
                  <h2>Detalle</h2>
                </div>

                <div class="result__content">
                  <div class="result__item">
                    <div class="result__name">
                      <span>Monto solicitado</span>
                    </div>

                    <div class="result__value">
                      <span>{{ request()?.quotes?.prices?.selected | currency }}</span>
                    </div>
                  </div>

                  <div class="result__item">
                    <div class="result__name">
                      <span>Cuota quincenal</span>
                    </div>

                    <div class="result__value">
                      <span>{{ request()?.quotes?.quota?.selected | currency }}</span>
                    </div>
                  </div>

                  <div class="result__item">
                    <div class="result__name">
                      <span>Total cuotas</span>
                    </div>

                    <div class="result__value">
                      <span>{{ request()?.quotes?.quota?.quantity }} cuotas quincenales</span>
                    </div>
                  </div>

                  <div class="result__item">
                    <div class="result__name">
                      <span>Próximo pago</span>
                    </div>

                    <div class="result__value">
                      <span>{{ returnPaymentDate() | date: 'dd/MM/yyyy' }}</span>
                    </div>
                  </div>

                  <div class="result__item result__item--total">
                    <div class="result__name">
                      <span>Total a pagar</span>
                    </div>

                    <div class="result__value">
                      <span>{{ (request()?.quotes?.quota?.selected * request()?.quotes?.quota?.quantity) | currency }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </article>

            <article class="cupo" *ngIf="isBetterProduct()">
              <div class="cupo__content">
                <div class="cupo__block">
                  <div class="icon">
                    <app-wallet-icon color="blue"></app-wallet-icon>
                  </div>

                  <div class="text">
                    <h3>¡Tenemos una gran oportunidad para ti!</h3>
                    <p>{{ 'Puedes acceder a un monto de crédito hasta' | termReplace }} <strong>{{ request()?.best_financeable_product?.quotes?.prices?.suggested | currency }}</strong>.</p>
                  </div>
                </div>

                <div class="cupo__btn">
                  <button pButton pRipple type="button" label="Cambiar mi cupo" class="p-button-secondary p-button-raised p-button-rounded w-full small no-shadow" (click)="showModal()"></button>
                </div>
              </div>
            </article>
          </div>

          <div class="content__footer">
            <button pButton pRipple type="button" label="Aceptar y continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" (click)="approveRequest()"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>


<!-- MODAL SIMULATOR -->
<p-dialog [(visible)]="visibleModalChangeQuota" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info pb-25">
          <h2>Cambiar mi cupo</h2>
        </div>
        <div class="dialog__form">
          <app-sales-simulator-kredicash-embedded-v3
            [mode]="'modal'"
            [initialProducts]="products()"
            [initialSalary]="request()?.simulation?.salary || 600"
            [externalCategoryId]="requestService.categoryId"
            [requestId]="requestId"
            (modalSaveEvent)="onModalSave($event)"
            *ngIf="visibleModalChangeQuota">
          </app-sales-simulator-kredicash-embedded-v3>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- MODAL APPROVED LESS -->
<p-dialog [(visible)]="visibleModalApprovedLess" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__icon">
          <div class="icon__state">
            <app-alert-icon color="color"></app-alert-icon>
          </div>
        </div>
        <div class="dialog__info pb-25">
          <h2>Información importante</h2>
          <p>Hemos evaluado tu solicitud y en esta ocasión podemos ofrecerte un cupo menor al solicitado.</p>
        </div>
        <div class="dialog__footer">
          <button pButton pRipple label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" (click)="visibleModalApprovedLess=false;"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- MODAL CHANGE SUCCESSFULLY  -->
<app-sales-status-message-modal-v3></app-sales-status-message-modal-v3>
